import { AppBar } from '../../navigations/AppBar';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { HeaderProps } from '../../interfaces/headerInterface';
import { Env } from '../../interfaces/globaleInterface';
import { getStoredPreviewNumber } from '../../services/previewEnvironmentService';

const propsToEnv = {
	local: {
		label: 'PHF Dashboard Local',
		color: 'green',
	},
	dev: {
		label: 'PHF Dashboard Dev',
		color: 'primary',
	},
	recette: {
		label: 'PHF Dashboard Recette',
		color: 'orange',
	},
	prod: {
		label: 'PHF Dashboard Prod',
		color: 'red',
	},
	preview: {
		label: 'PHF Dashboard PR Preview',
		color: '#7b1fa2',
	},
};

export default function Header(props: HeaderProps) {
	const { isConnected, toolbarIsOpen, env, toggleDrawer } = props;
	const envProps = propsToEnv[env];
	const previewNumber = env === Env.PREVIEW ? getStoredPreviewNumber() : null;
	const environmentLabel = previewNumber ? `PHF Dashboard PR #${previewNumber}` : envProps.label;

	return (
		<AppBar sx={{ backgroundColor: envProps.color }} position="absolute" open={toolbarIsOpen}>
			<Toolbar
				sx={{
					pr: '24px', // keep right padding when drawer closed
				}}
			>
				<IconButton
					edge="start"
					color="inherit"
					aria-label="open drawer"
					onClick={() => {
						toggleDrawer();
					}}
					sx={{
						marginRight: '36px',
						...(toolbarIsOpen && { display: 'none' }),
					}}
				>
					{isConnected && <MenuIcon />}
				</IconButton>
				<Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
					{environmentLabel}
				</Typography>
			</Toolbar>
		</AppBar>
	);
}
